import { motion } from "framer-motion";

export default function SectionHeading({
  overline,
  title,
  subtitle,
  align = "center",
  className = "",
}) {
  const alignClass =
    align === "center"
      ? "text-center mx-auto"
      : align === "left"
      ? "text-left"
      : "text-right";

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`max-w-3xl ${alignClass} ${className}`}
    >
      {overline && (
        <span className="block font-sans text-xs md:text-sm font-medium uppercase tracking-[0.2em] text-gold-dark mb-3">
          {overline}
        </span>
      )}
      {title && (
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-semibold text-aura-text leading-tight">
          {title}
        </h2>
      )}
      {subtitle && (
        <p className="mt-4 font-sans text-base md:text-lg text-aura-text leading-relaxed">
          {subtitle}
        </p>
      )}
    </motion.div>
  );
}
